import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-pool',
  templateUrl: './pool.component.html',
  styleUrls: ['./pool.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoolIconComponent {}
